import axios from 'axios';
import {
  GET_PROSPECT_BILLING_INFO_ENDPOINT,
  GET_PROSPECT_BILLING_INVOICE_ENDPOINT,
  GET_RECURRING_BILLING_ENDPOINT,
  UNENROLL_AUTOPAY_ENDPOINT,
} from '../constants/endpoint';

const GetBillingInfo = async (prospectId, contactId) => {
  const response = await axios.get(`${GET_PROSPECT_BILLING_INFO_ENDPOINT}/${prospectId}?contactId=${contactId}`);

  return response;
};

const GetBillingInvoice = async (invoiceKey, prospectId, contactId) => {
  const response = await axios.get(`${GET_PROSPECT_BILLING_INVOICE_ENDPOINT}/${invoiceKey}?prospectId=${prospectId}&contactId=${contactId}`);

  return response;
};

const GetRecurringBilling = async contractId => {
  const response = await axios.get(`${GET_RECURRING_BILLING_ENDPOINT}/${contractId}`);

  return response;
};

const UnenrollAutopay = async prospectId => {
  const response = await axios.post(`${UNENROLL_AUTOPAY_ENDPOINT}/${prospectId}`);

  return response;
};

export { GetBillingInfo, GetBillingInvoice, GetRecurringBilling, UnenrollAutopay };
